import styled from "styled-components";
import React from "react";
import { Modal } from "antd";
import SmallButton from "modules/Content/Shared/SmallButton";
import { ReactComponent as Cross } from "assets/img/icons/cross.svg";
import { ReactComponent as Error } from "assets/img/icons/errorGreen.svg";

interface IDialogBox {
  isWarning: boolean;
  heading: string;
  isBodyVisible: boolean;
  isModalOpen: boolean;
  bodyText?: string;
  proceedHandler: () => void;
  proceedBtnText: string;
  closeHandler: (type?: string) => void;
  isCloseBtnVisible?: boolean;
  closeBtnText?: string;
  isCenterAligned?: boolean;
  clickOutsideClose?: boolean;
}

const DialogBox: React.FC<IDialogBox> = (props) => {
  const {
    isWarning,
    heading,
    isBodyVisible,
    bodyText,
    isModalOpen,
    proceedHandler,
    proceedBtnText,
    closeHandler,
    children,
    isCloseBtnVisible,
    closeBtnText,
    isCenterAligned,
    clickOutsideClose
  } = props;

  return (
    <>
      <StyledModal
        isWarning={isWarning}
        visible={isModalOpen}
        footer={null}
        closeIcon={<Cross />}
        width={isWarning ? "654px" : "582px"}
        zIndex={isBodyVisible ? 1000 : 2000}
        onCancel={() => closeHandler("cancel")}
        centered
        {...(clickOutsideClose === false ? { maskClosable: false } : {})}
        isCenterAligned={isCenterAligned}
      >
        <Wrapper>
          {/* Title */}
          {
            heading && (<div>
              <h3 className="title_styles">{heading}</h3>
            </div>)
          }
          {
            isWarning && (<div className="warning">
              <div><Error /></div>
              <p className="warning-text">{bodyText}</p>
            </div>)
          }
          {/* If Deleting a condition control */}
          {isBodyVisible ? (
            <div className="box-body">
              <p className="message">
                {bodyText}
              </p>
              {children}
            </div>
          ) : null}
          {/* Buttons */}
          <div className="buttons">
            <SmallButton title={proceedBtnText} outline="btns success-btn" onClick={proceedHandler} />
            {
              isCloseBtnVisible && (<SmallButton title={closeBtnText} outline="outline btns" onClick={closeHandler} />)
            }
          </div>
        </Wrapper>
      </StyledModal>
    </>
  );
};

DialogBox.defaultProps = {
  isWarning: false,
  isCloseBtnVisible: true,
  closeBtnText: 'Cancel',
  isCenterAligned: true,
}

export default DialogBox;

const Wrapper = styled.div`
  .title_styles {
    text-align: center;
    margin-top: 20px;
    font-weight: 700;
    color: #424b50;
    font-size: 32px;
  }
  .buttons {
    text-align: center;
    margin-top: 48px;
    margin-bottom: 17px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      margin-top: 30px;
    }
  }
  .btns {
    padding: 8px 32px;
    font-family: Helvetica;
    font-size: 16px;
    font-weight: 700;
    border-width: 2px;
    border-radius: 32px;
    &.success-btn {
      margin-right: 16px;
    }
  }
  .message {
    font-family: "Roboto", sans-serif;
    font-weight: 400;
    font-size: 20px;
    color: #5e7079;
    text-align: center;
    margin-bottom: 24px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 16px;
    }
  }
  .options {
    font-family: "Roboto", sans-serif;
    font-weight: 700;
    font-size: 16px;
    color: #424b50;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 16px;
    }
  }
  .box-body {
    margin-bottom: 48px;
  }
  .radio_group {
    text-align: center;
  }
  .warning {
    display: flex;
    /* align-items: center; */
    border-top-right-radius: 18px;
    border-top-left-radius: 18px;
    background: #DEF6E6;
    padding: 40px 32px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      padding: 32px 30px;
      padding-right: 44px;
    }
    .warning-text {
      margin-left: 16px;
      white-space: pre-line;
      font-family: "Roboto", sans-serif;
      font-weight: 500;
      font-size: 20px;
      color: #5E7079;
      margin-bottom: 0;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 18px;
      }
    }
  }
`;

type IStyledModal = {
  isWarning: boolean,
  isCenterAligned?: boolean,
}

const StyledModal = styled(Modal) <IStyledModal>`
    vertical-align: ${(props) => (props.isCenterAligned ? "middle" : "initial !important;")};
    top: ${(props) => (props.isCenterAligned ? "0" : "30px !important;")};
  & .ant-modal-content {
    border-radius: 18px;
  }
  & .ant-modal-body {
    padding: ${(props) => (props.isWarning ? "0px" : "16px")};
    padding-bottom: 16px;
  }
`;